import isEmpty from 'lodash/isEmpty';
import { checkDateIsInSamePeriod } from 'app/utils/checkDateIsInSamePeriod';

export const getAddressValidationState = (street) => {
    const validationState = {
        hasError: false,
        errorText: '',
    };

    const streetIsValid = !!street?.data?.house && street?.value.trim() !== '';

    const isAddressWrong = isEmpty(street?.data) && (street.value && street?.value.trim() !== '');
    const isHouseEmpty = !street.data.house && (street.value && street?.value.trim() !== '');
    const isAddressEmpty = isEmpty(street?.data) && !street?.value;
    const isContainKladrId = !!street?.data?.house_kladr_id || !!street?.data?.house_fias_id;
    const isHouseValid = street?.data?.house ?? isContainKladrId;

    const inputHasError = !streetIsValid
        || isAddressWrong
        || isAddressEmpty
        || isHouseEmpty
        || !isHouseValid;

    if (inputHasError) {
        validationState.hasError = inputHasError;

        if (isAddressEmpty) {
            validationState.errorText = 'Введите адрес';
        } else if (isAddressWrong) {
            validationState.errorText = 'Некорректный адрес';
        } else if (isHouseEmpty) {
            validationState.errorText = 'Не введен номер дома';
        }
    }
    return validationState;
};

export const mapDates = (fetchedDates, period, config, basketDishesIds, filtersContext) => {
    const flatDates = fetchedDates || [];

    const sortedDates = [...flatDates]
        .sort((d1, d2) => (new Date(d1.date)) - (new Date(d2.date)));

    const filteredSortedDates = sortedDates.filter((d) => {
        const isDateInSamePeriod = checkDateIsInSamePeriod(d.date, period);
        return isDateInSamePeriod;
    });

    if (!config) {
        return filteredSortedDates;
    }

    const { prepareDates, ignorePeriodForDeliveryDates } = config;

    if (!prepareDates) {
        const periodObj = filtersContext.visiblePeriods.find((p) => p.start === filtersContext.period);

        if (config.areAvaliableDishesPersistentForPeriods || !periodObj) {
            return filteredSortedDates;
        }

        const maxDate = new Date(periodObj.end);

        return filteredSortedDates.filter((d) => {
            const date = new Date(d.date);
            return date <= maxDate;
        });
    }
    const periodsConfig = config.periods;

    if (ignorePeriodForDeliveryDates) {
        return prepareDates(sortedDates, periodsConfig, period, basketDishesIds);
    }
    return prepareDates(filteredSortedDates, periodsConfig, period, basketDishesIds);
};


export const mapIntervals = (fetchedIntervals, deliveryDate, address, config) => {
    if (!config) {
        return fetchedIntervals;
    }

    const { prepareIntervals } = config;

    if (!prepareIntervals) {
        return fetchedIntervals;
    }

    return prepareIntervals(fetchedIntervals, deliveryDate, address);
};

export const mapAllDishesTags = (sections) => {
    const dishesTagsCollection = sections
        ?.flatMap((section) => section.items)
        .flatMap((item) => item.dish)
        .reduce((acc, dish) => {
            acc[dish.id] = dish.tags;
            return acc;
        }, {}) || [];
    return Object.values(dishesTagsCollection).flat();
};


export const getInvoiceTags = (basketDishesIds, config) => {
    if (!config || !config.getInvoiceTags) {
        return [];
    }
    return config.getInvoiceTags(basketDishesIds);
};


export default {
    getAddressValidationState,
};
